import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

const whiteLabelSelector = (state: RootState) => state.whiteLabel;

export const whiteLabelConfigSelector = createSelector(
  whiteLabelSelector,
  (whiteLabel) => whiteLabel.config,
);

export const whiteLabelLoadingSelector = createSelector(
  whiteLabelSelector,
  (whiteLabel) => whiteLabel.loading,
);

export const whiteLabelErrorSelector = createSelector(
  whiteLabelSelector,
  (whiteLabel) => whiteLabel.error,
);

// Convenience selectors for specific config values
export const siteNameSelector = createSelector(
  whiteLabelConfigSelector,
  (config) => config?.site_name || 'Ticket Spot',
);
export const dashboardUrlSelector = createSelector(
  whiteLabelConfigSelector,
  (config) => config?.dashboard_url,
);

export const brandColorsSelector = createSelector(whiteLabelConfigSelector, (config) => ({
  background: config?.brand_background_color || '#9b26db',
  secondary: config?.brand_secondary_color || '#E60023',
  text: config?.brand_text_color || '#ffffff',
}));

export const logoUrlSelector = createSelector(
  whiteLabelConfigSelector,
  (config) => config?.logo_url || 'https://cdn.ticketspot.io/logo.png',
);

export const shouldRemoveBrandingSelector = createSelector(
  whiteLabelConfigSelector,
  (config) => config?.remove_ticket_spot_branding || false,
);

export const isDefaultBrandingSelector = createSelector(
  whiteLabelConfigSelector,
  (config) => config?.default ?? true, // Default to true if not set
);
